import { Grid } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import css from 'assets/scss/heroSection.module.scss';
import CircularProgressWithLabel from '@Common/components/CircularProgressWithLabel';
import React, { useState, useEffect } from 'react';

const useStyles = makeStyles((theme) => ({
  roundedBoxHolderNew: {
    maxWidth: '250px',
    [theme.breakpoints.up('xs')]: {
      maxWidth: '170px',
    },

    '& p': {
      [theme.breakpoints.down('md')]: {
        fontSize: '15px',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '15px',
      },
    },
  },
}));
const HeroSectionNew = () => {
  const [progress, setProgress] = useState(0);
  const [userCount, setUserCount] = useState(0);
  const [progressStu, setProgressStu] = useState(0);
  const classes = useStyles();

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 75) {
          clearInterval(timer);
          return 75;
        }
        return prevProgress + 5;
      });
    }, 200);
    const timerForUserCount = setInterval(() => {
      setUserCount((prevUserCount: number) => {
        if (prevUserCount >= 50) {
          clearInterval(timerForUserCount);
          return 50;
        }
        return +(prevUserCount + 5).toFixed(1);
      });
    }, 200);

    const timerStu = setInterval(() => {
      setProgressStu((prevProgressStu) => {
        if (prevProgressStu >= 85) {
          clearInterval(timerStu);
          return 85;
        }
        return prevProgressStu + 5;
      });
    }, 200);

    return () => {
      clearInterval(timer);
      clearInterval(timerForUserCount);
      clearInterval(timerStu);
    };
  }, []);

  return (
    <div className={`${css.container}  `}>
      <div className={` ${css.topRoundedBoxHolder} `}>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={4} md={4} lg={4}>
            <div className={`${css.roundedBoxHolder} ${classes.roundedBoxHolderNew} `} style={{}}>
              <CircularProgressWithLabel
                value={progress}
                valuetext={`${progress}%`}
                bottomtext="time saved"
              />

              <p>Average time savings per writing project.</p>
            </div>
          </Grid>
          <Grid item xs={12} sm={4} md={4} lg={4}>
            <div className={`${css.roundedBoxHolder}  ${classes.roundedBoxHolderNew} `}>
              <CircularProgressWithLabel
                value={userCount * 2}
                valuetext={`${userCount}+`}
                bottomtext="million"
              />
              <p>Trusted by millions worldwide.</p>
            </div>
          </Grid>
          <Grid item xs={12} sm={4} md={4} lg={4}>
            <div className={`${css.roundedBoxHolder}  ${classes.roundedBoxHolderNew} `}>
              <CircularProgressWithLabel
                value={progressStu}
                valuetext={`${progressStu}%`}
                bottomtext="of students"
              />
              <p>Who reported their grades improved after using QuillBot.</p>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default HeroSectionNew;
